import React from 'react';
import { Mail, CreditCard, Download } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-2 px-4" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-118">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-1 md:gap-4 text-center" data-id="element-119">
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-120">
            <div className="w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 flex-shrink-0" data-id="element-121">
              <Mail className="w-3.5 h-3.5" data-id="element-122" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-123">
              <span className="font-bold" data-id="element-124">1.</span> Comprás e ingresás tu correo
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-125">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-126">
            <div className="w-7 h-7 bg-green-100 rounded-full flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-127">
              <CreditCard className="w-3.5 h-3.5" data-id="element-128" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-129">
              <span className="font-bold" data-id="element-130">2.</span> Pagás de forma segura
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-131">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-132">
            <div className="w-7 h-7 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 flex-shrink-0" data-id="element-133">
              <Download className="w-3.5 h-3.5" data-id="element-134" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-135">
              <span className="font-bold" data-id="element-136">3.</span> Recibís el link de descarga
            </p>
          </div>
        </div>

        <p className="mt-1.5 text-xs text-gray-500 text-center" data-id="element-137">
          ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
        </p>
      </div>
    </section>;
}